import React from "react";
import IndexedFormRow from "../IndexedFormRow";
import CollapseContainer from "../../CollapseContainer/CollapseContainer";
import { Field } from "redux-form";
import { renderField } from "../../../utils/formUtils";
import PrivacyRow from "../PrivacyRow/PrivacyRow";
import { Translate } from "react-localize-redux";

const FaxNumberFormPanel = () => (
  <CollapseContainer
    title={<Translate id="FaxNumbers" />}
    startCollapsed={true}
  >
    <IndexedFormRow
      modelArrayName="fax_numbers"
      privacyRow={<PrivacyRow rowOffset={10} />}
      dataComponent={member => (
        <Field
          name={`${member}.number`}
          type="text"
          hideLabel={true}
          component={renderField}
          label="number"
        />
      )}
    />
  </CollapseContainer>
);

export default FaxNumberFormPanel;



// WEBPACK FOOTER //
// ./src/components/forms/FaxNumberFormPanel/FaxNumberFormPanel.jsx